import { PricingType } from './types';

// export const pricingType: PricingType[] = [
//   {
//     title: 'PASS plan',
//     price: '$2.5/min',
//     description:
//       'Pay the usage fee in time for PASS to communicate with the ground station according to the orbit of the satellite!'
//   },
//   {
//     title: 'Rental plan',
//     price: 'Coming Soon',
//     description:
//       'Rent the entire ground station (S/W and H/W for communication) for a unit time and use it as much as you want!'
//   },
//   {
//     title: 'Custom plan',
//     price: 'Customized',
//     description: 'Create your own service and discuss it with a satellite operations expert!'
//   }
// ];

export const pricingType: PricingType[] = [
  {
    title: 'pricing.plans.pass.title',
    price: 'pricing.plans.pass.price',
    description: 'pricing.plans.pass.description'
  },
  {
    title: 'pricing.plans.rental.title',
    price: 'pricing.plans.rental.price',
    description: 'pricing.plans.rental.description'
  },
  {
    title: 'pricing.plans.custom.title',
    price: 'pricing.plans.custom.price',
    description: 'pricing.plans.custom.description'
  }
];